import { render, staticRenderFns } from "./DestSlides2.vue?vue&type=template&id=5c8311a5&scoped=true&lang=pug&"
import script from "./DestSlides2.vue?vue&type=script&lang=js&"
export * from "./DestSlides2.vue?vue&type=script&lang=js&"
import style0 from "./DestSlides2.vue?vue&type=style&index=0&id=5c8311a5&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c8311a5",
  null
  
)

export default component.exports